<template>
  <custom-popup
    v-model="dialog"
    :cons="cons"
    hide-confirm
    max-width="1024"
    reloadable
    @close="resetFields"
  >
    <v-card class="pa-4" flat>
      <v-progress-linear v-show="loading" class="mb-2" indeterminate />

      <vue-table :data="orders" :headers="headers" @change="onPagination">
        <template v-slot:user.name="{ item }">
          {{ item.user.name }} {{ item.user.family }}
        </template>

        <template v-slot:user.mobile="{ item }">
          {{ item.user.mobile }}
        </template>

        <template v-slot:payment_type="{ item }">
          {{ pt(item.payment_type) }}
        </template>

        <template v-slot:price="{ item }">
          {{ use_lang(price(item.appointment.price)) }}
        </template>

        <template v-slot:status="{ item }">
          <div :class="orderStatus(item).color" class="badge white--text">
            <div>{{ orderStatus(item).text }}</div>
          </div>
        </template>

        <template v-slot:action="{ item }">
          <orders-list-button :data="item" :meta="metaButtons" />
        </template>
      </vue-table>

      <!--      <data-table-->
      <!--        :columns="orderColumns"-->
      <!--        :data="{data: orders}"-->
      <!--        :debounce-delay="3000"-->
      <!--        :per-page="[10, 25, 50, 100, 500]"-->
      <!--        :translate="translate"-->
      <!--        class="pt-5 mt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"-->
      <!--        @on-table-props-changed="reloadTable"-->
      <!--      />-->
    </v-card>

    <custom-popup
      v-model="show"
      :cons="{ title: 'نوبت رزرو شده' }"
      hide-confirm
      max-width="450"
    >
      <v-card
        v-if="!!computedAppointment && !!computedAppointment.appointment"
        flat
      >
        <v-card-title class="font-size-h6">
          {{ dateString(computedAppointment.appointment.reserve_time) }}
        </v-card-title>
        <v-card-text>
          مبلغ :
          <b class="black--text mx-2">{{
            use_lang(price(computedAppointment.appointment.price))
          }}</b>
          ﷼

          <template v-if="!!computedAppointment.appointment.discount">
            <br />
            تخفیف:
            <b class="black--text mx-2"
              >{{ computedAppointment.appointment.discount }}٪</b
            >
          </template>
        </v-card-text>
      </v-card>
    </custom-popup>
  </custom-popup>
</template>

<script>
// TODO: remove comments
// import {dataTableProps} from "@/main";
import OrdersListButton from "@/view/components/adapters/qrList/ordersListButton.vue";

export default {
  name: "qrAppointmentsList",

  components: { OrdersListButton },

  props: {
    value: Boolean,
    address: String,
  },

  data() {
    return {
      info:{},
      cons: {
        title: "نوبت‌های رزرو شده",
      },
      headers: [
        { value: "id", text: "شماره سفارش", sortable: false, align: "center" },
        {
          value: "user.name",
          text: "نام مشتری",
          sortable: false,
          align: "center",
        },
        {
          value: "user.mobile",
          text: "شماره همراه",
          sortable: false,
          align: "center",
        },
        {
          value: "payment_type",
          text: "روش پرداخت",
          sortable: false,
          align: "center",
        },
        { value: "price", text: "مبلغ", sortable: false, align: "center" },
        { value: "status", text: "وضعیت", sortable: false, align: "center" },
        { value: "action", text: "عملیات", sortable: false, align: "center" },
      ],
      metaButtons: {
        buttons: [
          {
            name: "appointment",
            label: "مشاهده نوبت",
            icon: "calendar-month",
            class: "btn-outline-info",
            action: this.actions,
          },
          {
            name: "changeOrderStatus",
            label: "تغییر به پرداخت شده",
            icon: "swap-horizontal-circle-outline",
            class: "btn-accept rounded-pill",
            conditions: "this.data.status !== 'reserved'",
            action: this.actions,
          },
        ],
      },
      // orderColumns: [
      //   {
      //     label: 'شماره سفارش',
      //     name: 'id',
      //   }, {
      //     label: 'نام مشتری',
      //     name: 'user.name',
      //     transform: ({data}) => data.user?.name + ' ' + data.user?.family
      //   }, {label: 'شماره همراه', name: 'user.mobile',}, {
      //     label: 'روش پرداخت',
      //     name: 'payment_type',
      //     transform: ({data}) => this.pt(data.payment_type)
      //   }, {
      //     label: 'مبلغ سفارش',
      //     name: 'price',
      //     transform: ({data}) => this.price(data.appointment.price) + ' ریال'
      //   }, {
      //     label: 'وضعیت',
      //     name: 'status',
      //     transform: ({data}) => `<div class="status-chip btn ${this.orderStatus(data).color}"><div>${this.orderStatus(data).text}</div></div>`
      //   }, {
      //     label: 'عملیات',
      //     name: 'action',
      //     component: ordersListButton,
      //     event: "actions",
      //     meta: {
      //       buttons: [{
      //         name: 'appointment',
      //         label: 'مشاهده نوبت',
      //         icon: 'calendar-month',
      //         class: 'btn-outline-info',
      //         action: this.actions,
      //       }, {
      //         name: 'changeOrderStatus',
      //         label: 'تغییر وضعیت',
      //         icon: 'list-status',
      //         class: 'btn-outline-accept',
      //         action: this.actions,
      //       },
      //         // {
      //         //     name: 'print',
      //         //     label: 'پرینت سفارش',
      //         //     icon: 'printer-outline',
      //         //     class: 'btn-outline-info',
      //         //     action: this.actions,
      //         //   }, {
      //         //     name: 'share',
      //         //     label: 'اشتراک گذاری سفارش',
      //         //     icon: 'share-variant-outline',
      //         //     class: 'btn-outline-info',
      //         //     action: this.actions,
      //         // }
      //       ]
      //     }
      //   },
      // ],
      orders: {},
      tabs: 0,
      tabItems: [
        { text: "سفارشات", icon: "" },
        { text: "کاربران", icon: "" },
      ],
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
        page: 1,
      },
      // translate: dataTableProps.translate,
      loading: false,
      show: false,
      showIndex: null,
    };
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    url() {
      return this.info.domain?.name + this.info.identifier;
    },
    computedAppointment() {
      return this.orders?.data?.[this.showIndex];
    },
  },

  watch: {
     value(val) {
      if (val) {
        this.fetchData().then(() => {
          this.fetch();
        });
      }
    },  },

  methods: {
 fetchData() {
      this.loading = true;
      console.log(this.address, "qrapponmentslist");

      return this.$api
        .get(`/v1/testQr/find/${this.address}`)
        .then(({ data }) => {
          this.info = data.data;
        })
        .finally(() => (this.loading = false));
    },
        fetch(params = this.tableProps) {
      this.loading = true;

      this.$api
        .get(`/v1/testQr/find/appointments/${this.url}`, {
          params,
        })
        .then(({ data }) => {
          this.orders = data.data;
        })
        .finally(() => (this.loading = false));
    },
    onPagination(e) {
      let props = {
        ...this.tableProps,
        ...e,
      };

      this.fetch(props);
    },
    pt(t) {
      switch (t) {
        case "online":
          return "پرداخت آنلاین";
        case "place":
          return "پرداخت در زمان نوبت";
      }
    },
    resetFields() {
      this.orders = {};
      this.users = [];
    },
    orderStatus(data) {
      let s = data.status;
      switch (s) {
        case "pending":
          return {
            text: "در انتظار پرداخت",
            color: "warning",
          };
        case "accepted":
        case "reserved":
          return {
            text:
              data.payment_type === "place" ? "پرداخت در محل" : "پرداخت شده",
            color: data.payment_type === "place" ? "info" : "success",
          };
        case "rejected":
          return {
            text: "پرداخت ناموفق",
            color: "red",
          };
        default:
          return {
            text: "",
            color: "",
          };
      }
    },
    actions(data, type) {
      this[type + "Action"](data);
    },
    appointmentAction(data) {
      this.showIndex = this.orders.data.findIndex(
        (item) => item.id === data.id
      );
      this.show = true;
    },
    changeOrderStatusAction(data) {
      this.loading = true;

      this.$api
        .post(`/v1/testQr/change/order-status/${this.url}`, {
          id: data.id,
        })
        .then(({ data }) => console.log("data: ", data))
        .catch(({ response }) =>
          console.log("failed to change order status: ", response)
        )
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped></style>
